import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAccessControl } from "../hooks/useAccessControl";
import { Loader2 } from "lucide-react";

interface InstructorAccessGuardProps {
  children: ReactNode;
  redirectTo?: string;
}

export default function InstructorAccessGuard({ 
  children, 
  redirectTo = "/instructor/dashboard"
}: InstructorAccessGuardProps) {
  const { hasAccess, isLoading } = useAccessControl();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !hasAccess) {
      navigate(redirectTo, { replace: true });
    }
  }, [hasAccess, isLoading, navigate, redirectTo]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
}
